//
// README - Beta Component
//
// This component is marked "beta" and will go through some iterations
// before landing at a final solution. Please reach out to the Cadence team
// if you intend to use this in the meantime and we'll help you out!
//

import classNames from 'classnames';
import React from 'react';

export interface RCEyebrowProps {
  text?: string;
  type?: 'default' | 'highlight' | 'alert';
  inverted?: boolean;
  collapseWhenEmpty?: boolean;
}

export function RCEyebrow({
  text = undefined,
  type = 'default',
  collapseWhenEmpty = false,
  inverted = false,
}: RCEyebrowProps) {
  return (
    <div className={classNames(
      'rc-eyebrow',
      {
        'rc-eyebrow--highlight': type === 'highlight',
        'rc-eyebrow--alert': type === 'alert',
        'rc-eyebrow--collapse': collapseWhenEmpty,
        'rc-eyebrow--inverted': inverted,
      },
    )}>
      {text}
    </div>
  );
}
